import React, { useEffect, useState } from "react";
import { Button } from "../../common/Button/Button";
import api from "../../utils/api";
import Spinner from "../../common/Spinner/Spinner";
import { toast } from "react-toastify";
import { DOWNLOAD_API_URL } from "../../utils/constants";
import ReactDatePicker from "react-datepicker";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import { getUser } from "../../utils/localStorage";

export default function PaymentTrackerReportContainer(props) {
  const [isLoading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [extPartnerList, setExtPartnerList] = useState([]);
  const [selectedExtPartner, setSelectedExtPartner] = useState([]);

  useEffect(() => {
    const fetchPartnerList = async () => {
      try {
        const { data } = await api.allExtPartnerList();
        const filteredPartnerList = data.filter(
          (ele) =>
            ele.sServicePartnerEmail !== null &&
            ele.sServicePartnerEmail !== ""
        );
        const formattedData = filteredPartnerList.map((partner) => ({
          value: partner.sServicePartnerEmail,
          label: `${partner.sName} (${partner.sServicePartnerEmail})`,
        }));
        setExtPartnerList([...formattedData]);
      } catch (error) {
        console.log(error);
      }
    };

    fetchPartnerList();
  }, []);

  const toDateAdjusted = (date) => {
    let toDateAdjusted;
    if (date) {
        toDateAdjusted = new Date(date);

        toDateAdjusted = new Date(
            toDateAdjusted.setTime(
                // toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
                toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
            )
        );
    }
    return toDateAdjusted;
}

const fromDateAdjusted = (date) => {
    let toDateAdjusted;
    if (date) {
        toDateAdjusted = new Date(date);

        toDateAdjusted = new Date(
            toDateAdjusted.setTime(
                // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
                toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
            )
        );
    }
    return toDateAdjusted;
}

  // const onSearchClick = () => {
  //   if (!fromDate || !toDate) {
  //     toast("Please select both From Date and To Date", {
  //       autoClose: 5000,
  //       type: toast.TYPE.ERROR,
  //     });
  //   } else if (selectedExtPartner.length === 0) {
  //     toast("Please select at least one Service Partner", {
  //       autoClose: 5000,
  //       type: toast.TYPE.ERROR,
  //     });
  //   } else {
  //     const partnerList = selectedExtPartner.map((partner) => partner.value);
  //     const payload = {
  //       fromDate: fromDateAdjusted(fromDate),
  //       toDate: toDateAdjusted(toDate),
  //       ServicePartnerEmail: partnerList,
  //     };
  //     setLoading(true);
  //     console.log(payload);
  //     api
  //       .monthlyPaymentTrackerReport(payload)
  //       .then(({ data }) => {
  //         setLoading(false);
  //         if (data && data.generated_file) {
  //           window.open(data.generated_file, "_self");
  //         }
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         console.error("Error fetching data:", error);
  //       });
  //   }
  // };

  const onSendByEmail = () => {
    let user = getUser();
    let email = user?.email;
    console.log(email, ">>>user in payment tracker")
    if(!email){
      toast("Not a valid user", {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
    }else if(!fromDate || !toDate) {
      toast("Please select both From Date and To Date", {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
    } else if (selectedExtPartner.length === 0) {
      toast("Please select at least one Service Partner", {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
    } else {
      const partnerList = selectedExtPartner.map((partner) => partner.value);
      const payload = {
        sfrom_date: fromDateAdjusted(fromDate),
        sto_date: toDateAdjusted(toDate),
        sUser: email,
        sServicePartnerEmail: partnerList,
        dtRequested: new Date(),
        bsEmailSentFlag: false
      };
      setLoading(true);
      console.log(payload);
      api
        .savePaymentSettlementEmail(payload)
        .then((res) => {
          setLoading(false);
          setLoading(true);
          toast("Report will be send on your Email-Id.", {
            autoClose: 5000,
            type: toast.TYPE.SUCCESS,
          });
          api.generateAndSendReport()
          .then(res => {
            console.log(res, ">>>Res of generateAndSendReport")            
            setLoading(false);      
          })
          .catch(err => {
            // console.error("Error sending report data:", err);
            toast("Failed to send report", {
              autoClose: 5000,
              type: toast.TYPE.ERROR,
            });
            setLoading(false);
          })
        })
        .catch((error) => {
          setLoading(false);
          // console.error("Error data:", error);
          toast("Failed to save record", {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
          });
        });
    }
  };

  const onClearClick = () => {
    setSelectedExtPartner([]);
    setFromDate(null);
    setToDate(null);
  };

  const onExtPartnerChange = (options) => {
    const isAllSelected = options.some((opt) => opt.value === "*");
    if (isAllSelected) {
      setSelectedExtPartner([{ value: "*", label: "All" }]);
    } else {
      setSelectedExtPartner(options.filter((opt) => opt.value !== "*"));
    }
  };

  const toggleAll = () => {
    if (selectedExtPartner.length != extPartnerList.length && selectedExtPartner.length != (extPartnerList.length + 1)) {
      let temp = []

      if (selectedExtPartner.includes({ label: "All", value: "*" })) {
        temp = selectedExtPartner
      } else {
        temp = [{ label: "All", value: '*' }]
      }

      let tempSR = extPartnerList.map((e) => {
        if (!temp.includes(e)) {
          temp = temp.concat(e)
        }
        return e
      })
      setExtPartnerList(tempSR)
      setSelectedExtPartner(temp)
    } else {
      setSelectedExtPartner([])
    }

  }

  return (
    <>
      {isLoading && <Spinner className="center-screen" />}
      <div className={`${isLoading && "set-opacity"}`}>
        <br />
        <h5 className="mt-2">Payment Settlement Report:</h5>
        <br />
        <a
          className="con-cursor-pointer"
          href={`${DOWNLOAD_API_URL}/static_live/Reports/ServicePayTracker.xlsx`}
          download="ServicePayTracker.xlsx"
        >
          <Button>Services Payment Tracker Report</Button>
        </a>
        <span className="ml-2">
        <a
          className="con-cursor-pointer"
          href={`${DOWNLOAD_API_URL}/static_live/Reports/ServicePayTrackerJPMC.xlsx`}
          download="ServicePayTrackerJPMC.xlsx"
        >
          <Button>JPMC Payment Tracker Report</Button>
        </a>
        </span>

        <div className="row mt-2">
          <div className="col">
            <p>To Download Service Payment Tracker Report older than 1st Jan, 2024, {" "}
              <a
                className="con-cursor-pointer"
                href={`${DOWNLOAD_API_URL}/static_live/Reports/ServicePayTracker2020to2023.xlsx`}
                download="ServicePayTrackerOld.xlsx"
              >

                <span className="text-hover" style={{ cursor: 'pointer' }}>

                  Click here</span>
              </a>
            </p>
          </div>
        </div>


        <div className="row mt-3 mb-3">
          <div className="col">
            <h5>Monthwise Payment Settlement Report</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-2 spled-container conv-zindex">
            <div className="width-100">
              <ReactDatePicker
                dateFormat="dd/MM/yyyy"
                selected={fromDate}
                disabled={isLoading}
                onChange={(date) => setFromDate(date)}
                placeholderText="From Date"
                minDate={
                  toDate
                    ? new Date(toDate.getTime() - 181 * 24 * 60 * 60 * 1000)
                    : new Date("01-01-2013")
                }
              />
            </div>
          </div>
          <div className="col-2 spled-container conv-zindex">
            <div className="width-100">
              <ReactDatePicker
                dateFormat="dd/MM/yyyy"
                selected={toDate}
                disabled={isLoading}
                onChange={(date) => setToDate(date)}
                placeholderText="To Date"
                maxDate={
                  fromDate
                    ? new Date(fromDate.getTime() + 181 * 24 * 60 * 60 * 1000)
                    : null
                }
              />
            </div>
          </div>
          <div className={`col-4 d-flex align-items-center conv-zindex spled-container ${isLoading ? 'disabled-container': ''}`}>
            <div className="w-100">
              <MultiSelectAll
                toggleAll={toggleAll}
                toggleSelection={onExtPartnerChange}
                checkboxItemsList={extPartnerList}
                selectedOptions={selectedExtPartner}
                placeholderButtonLabel="Select Partner"
              />
            </div>
            {/* <div>
              <Button
                style={{ margin: 0, marginLeft: "10px", height: "37px" }}
                onClick={onSearchClick}
                className="esp-inline-button"
              >
                Download
              </Button>
            </div>
            */}

            <div>
              <Button
                style={{ margin: 0, marginLeft: "10px", height: "37px" }}
                onClick={onSendByEmail}
                disabled={isLoading}
                className="esp-inline-button"
              >
                Download {/* is Sending by email  */}
              </Button>
            </div>


            <div>
              <Button
                style={{
                  margin: 0,
                  marginLeft: "10px",
                  height: "37px",
                  backgroundColor: "#eaeaea",
                  border: "2px solid #000",
                  color: "#000",
                }}
                disabled={isLoading}
                onClick={onClearClick}
                className="esp-inline-button"
              >
                Clear
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}



